export interface PaypalShippingAddress {
  city: string | undefined;
  country: string | undefined;
  firstName: string | undefined;
  houseNumberOrName: string | undefined;
  postalCode: string | undefined;
  stateOrProvince: string | undefined;
  street: string | undefined;
}

export const getNamesFromShippingAddress = (
  shippingAddress?: PaypalShippingAddress,
) => {
  if (!shippingAddress?.firstName) return { firstName: '', lastName: '' };
  const name = shippingAddress.firstName?.trim() || '';
  const [firstName = '', ...rest] = name.split(/\s+/);
  const lastName = rest.join(' ');
  return { firstName, lastName };
};
